<template>
  <div class="home">
	    <div class="box">	
            <form @submit.prevent="saveOrganisationUser">
                    <div class="field">
                        <label class="label">Forename</label>
                        <div class="control">
                            <input class="input" type="text" v-model="forename" autofocus required>
                            
                        </div>
                    </div>
                    <div class="field">
                        <label class="label">Surname</label>
                        <div class="control">
                            <input class="input" type="text" v-model="surname" >
                            
                        </div>
                    </div>
                    <div class="field">
                        <label class="label">Email</label>
                        <div class="control">
                            <input class="input" type="email" v-model="email" required>
                            
                        </div>
                    </div>

                    <p><em>If the email address is valid, the new user will receive their password automatically by email.</em></p><br />
                    <div class="field">
                        <label class="label">Default Organisation</label>
                        <div class="control">
                            <select class="input" v-model="organisation_id" >
                              <option value="">Please select</option>
                              <option :value="row.id" v-for="row in organisations" :key="row.id">{{ row.name }}</option>
                            </select>
                            
                        </div>
                    </div>
                     <div class="field">
                        <label class="label">Volunteer Centre</label>
                        <div class="control">
                            <select class="input" v-model="company_id" required >
                              <option value="">Please select</option>
                              <option :value="row.id" v-for="row in user.companies" :key="row.id">{{ row.name }}</option>
                            </select>
                            
                        </div>
                    </div>
                    
                    

                   
                    <div class="field is-grouped">
                        <div class="control">
                            <button class="button is-success" :disabled="loading===true">Create Organisation User</button>
                        </div>
                    </div>
                </form>
          
        </div>
		
	</div>
</template>

<script>
import AwardsService from '@/services/AwardsService.js';
import AwardsMixin from '@/mixins/AwardsMixin.js';

export default {
  name: 'AddOrganisation',
	mixins: [AwardsMixin],
	data: function () {
    	return {
		      organisations: [],
              companies: [],
			  loading : true,
			  search: "",
				API_NAME: process.env.VUE_APP_API_NAME,
				accessToken: '',
        forename :'',
        surname : '',
        organisation_id:  this.$route.params.id,
        award: '',
        email: '',
        send_email: 1,
        user: [{companies: []}],
        company_id: ''
		}
	},
	created() {
      this.getAccessToken()
        .then(() => { 
           this.getOrganisations();
            this.getUserProfile();
        });
      
    },
	methods: {
		async getAccessToken() {
            this.accessToken = await this.$auth.getTokenSilently()
        },
		// Log the user in
		login() {
			this.$auth.loginWithRedirect();
		},
		async saveOrganisationUser() {
			this.loading = true;
			var formdata = { 
                forename : this.forename,
                 surname : this.surname,
                  organisation_id : this.organisation_id,
                  company_id : this.company_id,
                   email : this.email,
                   volunteer: 0,
                   organisation: 1
                   
            }; 

            AwardsService.saveOrganisationUser(this.accessToken, formdata)
            .then((response) => {
                 this.$router.push("/organisations/" + this.$route.params.id);
                 console.log(response)
                 this.loading = false;
                
                }).catch((error) => {
                    if(error.response.status === 422)
                    {
                        console.log("Error:" + JSON.stringify(error.response.data));
                    }
                    alert("Something went wrong. Make sure you have filled in all the fields. \nOr ring David !!")
                    this.loading = false;
            });
		},
    async getOrganisations() {
			this.loading = true
			AwardsService.getOrganisations(this.accessToken, this.search)
			.then(
				(organisations => {
				this.$set(this, "organisations", organisations);
                this.loading = false
				}).bind(this)
			);
		},
		
		
	},
    watch: {
        // whenever question changes, this function will run
        user () {
            this.company_id = this.user.companies[0].id
        }
    },
}
</script>
